module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "controlpanel"
    }
  }, [_c('nav', {
    staticClass: "navbar "
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    attrs: {
      "id": "navMenubd-example"
    }
  }, [_c('div', {
    staticClass: "navbar-start"
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item has-dropdown is-hoverable userProfile"
  }, [_c('a', {
    staticClass: "navbar-link"
  }, [_c('span', {
    staticClass: "icon user",
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v(_vm._s(_vm.userName) + "\n              "), _c('i', {
    staticClass: "fa fa-user"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-dropdown"
  }, [_c('router-link', {
    staticClass: "navbar-item logout",
    attrs: {
      "to": "/logout"
    }
  }, [_c('a', {
    staticClass: "navbar-item logout"
  }, [_vm._v(_vm._s(_vm.$t('upperPanel.logout')))])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "projects"
  }, [_c('ul', _vm._l((_vm.projects), function(project) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": '/map/' + project.id
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-image"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": project.thumbnailImgUrl,
        "alt": "Image"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-content"
    }, [_c('p', {
      staticClass: "title is-4"
    }, [_vm._v(_vm._s(project.projectName))]), _vm._v(" "), _c('p', {
      staticClass: "subtitle is-6"
    }, [_vm._v(_vm._s(project.clientName))])])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v("\n                " + _vm._s(project.meta.description) + "\n                "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(project.meta.date))])])])])])], 1)
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    staticClass: "navbar-item"
  }, [_c('img', {
    attrs: {
      "src": "https://staticcontentskymaps.blob.core.windows.net/static/static/logo_v2.png",
      "alt": "Skymaps"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger burger",
    attrs: {
      "data-target": "navMenubd-example"
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cd2ecea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ControlPanel.vue
// module id = 213
// module chunks = 1